import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pendingCancellationTitle: {
    description: 'Title for info banner account with a pending coupon that is cancelled but user still has access',
    defaultMessage: '<b>Continue with ShipStation and get {monthCount, plural, one {# month} other {# months}} for free</b>',
    id: '1sYsfr',
  },
  cancelledTitle: {
    description: 'Title for cancelled account banner with a pending coupon',
    defaultMessage: '<b>Subscription cancelled on {endDate}</b>',
    id: 'lrmZ5T',
  },
  pendingCancellationMessage: {
    description: 'User has an offer/coupon they can apply to their pending cancellation account',
    defaultMessage:
      "We're sorry to see you go! If you'd like to continue with your ShipStation subscription, you can undo your cancel request at any time before {endDate}. Click <i>Undo Cancellation and Apply Offer</i> to receive {monthCount, plural, one {# month} other {# months}} for free on your selected plan.",
    id: 'RjGJdG',
  },
  cancelledMessage: {
    description: 'User has an offer/coupon they can apply to their cancelled account',
    defaultMessage:
      "Your subscription was cancelled on {endDate} and your account is no longer active. If you'd like to continue using ShipStation, click <i>Renew Subscription and Apply Offer</i> to receive {monthCount, plural, one {# month} other {# months}} for free on your selected plan.",
    id: 'kDl1Cv',
  },
  pendingCancellationButton: {
    description: 'User has an offer/coupon they can apply to their pending cancellation account',
    defaultMessage: 'Undo Cancellation and Apply Offer',
    id: 'AOaSxO',
  },
  cancelledButton: {
    description: 'User has an offer/coupon they can apply to their cancelled account',
    defaultMessage: 'Renew Subscription and Apply Offer',
    id: '4mA45r',
  },
  planActiveException: {
    description: 'Vague error message to display for users',
    defaultMessage: 'An error occurred during processing.',
    id: 'X9GkEg',
  },
  applyCouponException: {
    description: 'Error message to display for users when we fail to apply a coupon to their subscription plan.',
    defaultMessage:
      'An error occurred while applying the coupon to your subscription plan. Please contact our Support team so that we may resolve this issue for you.',
    id: 'okG0W+',
  },
  generalException: {
    description: 'Error message to display for users when we fail to process the requested changes to their subscription plan.',
    defaultMessage:
      'An error occurred while processing the adjustments to your subscription plan. Please contact our Support team so that we may resolve this issue for you',
    id: '7XBYy7',
  },
});

export default messages;
